import { AVALARA_W9_STATUSES, DOC_STATUSES, DOC_TYPES, W9_STATUSES } from 'constants/documents';

export const getDocumentReferrer = () => document.referrer;

export const shouldUseAvalara = (document) =>
	document.type === DOC_TYPES.irs && AVALARA_W9_STATUSES.includes(document.status);

const shouldShowUploadRequiredNotice = (document) => (document.status || DOC_STATUSES.pending) === DOC_STATUSES.pending;

const shouldShowSignableRequiredNotice = (document) => document.status === DOC_STATUSES.pending;

const shouldShowAvalaraRequiredNotice = (document) => {
	const hasW9 = Boolean(document.document_id || document.has_w9);

	return (
		document.status === W9_STATUSES.verificationFailed ||
		(document.status === W9_STATUSES.pendingVerification && !hasW9)
	);
};

export const shouldShowRequiredDocumentNotice = (document = {}) => {
	if (!document.required) return false;

	if (document.type === DOC_TYPES.uploadable) return shouldShowUploadRequiredNotice(document);
	if (document.type === DOC_TYPES.signable) return shouldShowSignableRequiredNotice(document);
	if (document.type === DOC_TYPES.irs) {
		return shouldUseAvalara(document) ?
				shouldShowAvalaraRequiredNotice(document)
			:	shouldShowSignableRequiredNotice(document);
	}

	return false;
};

export const createDocumentLocalId = (document, index = 0) =>
	`${
		document?.document_id ?? document?.signature_id ?? document?.document_type ?? document?.type ?? 'document'
	}:${index}`;

export const enrichDocumentsWithLocalId = (documents = []) =>
	documents.map((document, index) =>
		document?.localId ? document : { ...document, localId: createDocumentLocalId(document, index) },
	);
